module.exports = __webpack_public_path__ + "img/schnellecke-logo.d91f1f27.jpg";